/**
 * Created by giscafer on 2017/4/15.
 * 复制源码修改覆盖
 * 添加事件延迟，支持中文输入
 * //modified by giscafer
 */
/*tslint:disable */


import {
    NgModule,
    Component,
    ViewChild,
    ElementRef,
    AfterViewInit,
    AfterContentInit,
    AfterViewChecked,
    DoCheck,
    Input,
    Output,
    OnDestroy,
    EventEmitter,
    ContentChildren,
    QueryList,
    TemplateRef,
    IterableDiffers,
    Renderer,
    forwardRef
} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NG_VALUE_ACCESSOR, ControlValueAccessor} from '@angular/forms';
import {InputTextModule} from '../inputtext/inputtext';
import {ButtonModule} from '../button/button';
import {PrimeNGSharedModule, PrimeTemplate} from '../common/shared';
import { ObjectUtils } from '../utils/objectutils';
import { DomHandler } from '../dom/domhandler';

export const /** @type {?} */ AUTOCOMPLETE_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => AutoComplete),
    multi: true
};
//modified by giscafer
let /** @type {?} */ optionsTemplate = `
                <ul *ngIf="panelVisible && hasChildren!=='hasChildren'" class="ui-autocomplete-items ui-autocomplete-list ui-widget-content ui-widget ui-corner-all ui-helper-reset">
                    <li *ngFor="let option of suggestions" [ngClass]="{'ui-autocomplete-list-item ui-corner-all':true,'ui-state-highlight':(highlightOption==option)}"
                        (mouseenter)="highlightOption=option" (mouseleave)="highlightOption=null" (click)="selectItem(option)">
                        <span *ngIf="!itemTemplate">{{field ? option[field] : option}}</span>
                        <ng-template *ngIf="itemTemplate" [pTemplateWrapper]="itemTemplate" [item]="option"></ng-template>
                    </li>
                </ul>
                <ul *ngIf="panelVisible && hasChildren==='hasChildren'" class="ui-autocomplete-items ui-autocomplete-list ui-widget-content ui-widget ui-corner-all ui-helper-reset">
                    <li *ngFor="let option of suggestions" [ngClass]="{'ui-autocomplete-list-item ui-corner-all':true}">
                       <div *ngIf="!itemTemplate" (click)="groupLabelClick($event)" class="ui-select-group-label">{{field ? option[field] : option.name}}</div>
                        <div *ngFor="let c of option.children"
                             class="ui-select-choices-row"
                              [ngClass]="{'ui-state-highlight':(highlightOption==c)}"
                             (click)="selectItem(c,$event)">
                          <a href="javascript:void(0)"  (mouseenter)="highlightOption=c" (mouseleave)="highlightOption=null" class="ui-select-choices-row-inner">
                            <span>{{field ? c[field] : c.name}}</span>
                          </a>
                        </div>
                        <ng-template *ngIf="itemTemplate" [pTemplateWrapper]="itemTemplate" [item]="option"></ng-template>
                    </li>
                </ul>
                
            `;
export class AutoComplete implements AfterViewInit,AfterContentInit,DoCheck,OnDestroy,AfterViewChecked,ControlValueAccessor {

     hasChildren: string;

     minLength: number = 1;

     delay: number = 300;

     style: any;

     styleClass: string;

     inputStyle: any;

     inputStyleClass: string;

     placeholder: string;

     readonly: boolean;

     disabled: boolean;

     maxlength: number;

     size: number;

     suggestions: any[];

     appendTo: any;

     completeMethod: EventEmitter<any> = new EventEmitter();

     onSelect: EventEmitter<any> = new EventEmitter();

     onUnselect: EventEmitter<any> = new EventEmitter();

     onFocus: EventEmitter<any> = new EventEmitter();

     onDropdownClick: EventEmitter<any> = new EventEmitter();

     field: string;

     scrollHeight: string = '200px';

     dropdown: boolean;

     multiple: boolean;

     tabindex: number;

     templates: QueryList<any>;
public itemTemplate: TemplateRef<any>;
public selectedItemTemplate: TemplateRef<any>;

    value: any;

    onModelChange: Function = () => {
    };

    onModelTouched: Function = () => {
    };

    timeout: any;
    timeout2: any;

    differ: any;

    panel: any;

    input: any;

    multipleContainer: any;

    panelVisible: boolean = false;

    documentClickListener: any;

    suggestionsUpdated: boolean;

    highlightOption: any;

    highlightOptionChanged: boolean;

    focus: boolean = false;

    dropdownFocus: boolean = false;

    filled: boolean;

     inputEL: ElementRef;
/**
 * @param {?} el
 * @param {?} domHandler
 * @param {?} differs
 * @param {?} renderer
 * @param {?} objectUtils
 */
constructor(public el: ElementRef,
public domHandler: DomHandler, differs: IterableDiffers,
public renderer: Renderer,
public objectUtils: ObjectUtils) {
        this.differ = differs.find([]).create(null);
    }
/**
 * @return {?}
 */
ngDoCheck() {
        // ////console.log(this.suggestions)
        let /** @type {?} */ changes = this.differ.diff(this.suggestions);
        if (changes && this.panel) {
            if (this.suggestions && this.suggestions.length) {
                this.show();
                this.suggestionsUpdated = true;
            }
            else {
                this.hide();
            }
        }
    }
/**
 * @return {?}
 */
ngAfterContentInit() {
        this.templates.forEach((item) => {
            switch (item.getType()) {
                case 'item':
                    this.itemTemplate = item.template;
                    break;

                case 'selectedItem':
                    this.selectedItemTemplate = item.template;
                    break;

                default:
                    this.itemTemplate = item.template;
                    break;
            }
        });
    }
/**
 * @return {?}
 */
ngAfterViewInit() {
        this.input = this.domHandler.findSingle(this.el.nativeElement, 'input');
        this.panel = this.domHandler.findSingle(this.el.nativeElement, 'div.ui-autocomplete-panel');

        if (this.multiple) {
            this.multipleContainer = this.domHandler.findSingle(this.el.nativeElement, 'ul.ui-autocomplete-multiple-container');
        }

        this.documentClickListener = this.renderer.listenGlobal('body', 'click', () => {
            this.hide();
        });

        if (this.appendTo) {
            if (this.appendTo === 'body')
                document.body.appendChild(this.panel);
            else
                this.domHandler.appendChild(this.panel, this.appendTo);
        }
    }
/**
 * @return {?}
 */
ngAfterViewChecked() {
        if (this.suggestionsUpdated) {
            this.align();
            this.suggestionsUpdated = false;
        }

        if (this.highlightOptionChanged) {
            let /** @type {?} */ listItem = this.domHandler.findSingle(this.panel, 'li.ui-state-highlight');
            if (listItem) {
                this.domHandler.scrollInView(this.panel, listItem);
            }
            this.highlightOptionChanged = false;
        }
    }
/**
 * @param {?} value
 * @return {?}
 */
writeValue(value: any): void {
        this.value = value;
        this.filled = this.value && this.value != '';
    }
/**
 * @param {?} fn
 * @return {?}
 */
registerOnChange(fn: Function): void {
        this.onModelChange = fn;
    }
/**
 * @param {?} fn
 * @return {?}
 */
registerOnTouched(fn: Function): void {
        this.onModelTouched = fn;
    }
/**
 * @param {?} val
 * @return {?}
 */
setDisabledState(val: boolean): void {
        this.disabled = val;
    }
/**
 * 改动方法
 * @param {?} event
 * @return {?}
 */
onInput(event) {
        let /** @type {?} */ value = event.target.value;
        if (!this.multiple) {
            //modified by giscafer on 2017-4-15 16:31:57
            //Cancel the search request if user types within the timeout
            if (this.timeout2) {
                clearTimeout(this.timeout2);
            }
            this.timeout2 = setTimeout(() => {
                this.value = value;
                this.onModelChange(value);
            }, this.delay)
            //modified by giscafer end
        }

        if (value.length === 0) {
            this.hide();
        }

        if (value.length >= this.minLength) {
            //Cancel the search request if user types within the timeout
            if (this.timeout) {
                clearTimeout(this.timeout);
            }

            this.timeout = setTimeout(() => {
                this.search(event, value);
            }, this.delay);
        }
        else {
            this.suggestions = null;
        }
        this.updateFilledState();
    }
/**
 * @param {?} event
 * @param {?} query
 * @return {?}
 */
search(event: any, query: string) {
        //allow empty string but not undefined or null
        if (query === undefined || query === null) {
            return;
        }

        this.completeMethod.emit({
            originalEvent: event,
            query: query
        });
    }
/**
 * @param {?} option
 * @param {?=} event
 * @return {?}
 */
selectItem(option: any, event?: any) {
        if (this.multiple) {
            this.input.value = '';
            this.value = this.value || [];
            if (!this.isSelected(option)) {
                this.value.push(option);
                this.onModelChange(this.value);
            }
        }
        else {
            this.input.value = this.field ? this.objectUtils.resolveFieldData(option, this.field) : option;
            this.value = option;
            this.onModelChange(this.value);
        }

        this.onSelect.emit(option);

        this.input.focus();

    }
/**
 * @param {?} event
 * @return {?}
 */
groupLabelClick(event: any) {
        event.stopPropagation();
    }
/**
 * @return {?}
 */
show() {
        if (!this.panelVisible && (this.focus || this.dropdownFocus)) {
            this.panelVisible = true;
            this.panel.style.zIndex = ++DomHandler.zindex;
            this.domHandler.fadeIn(this.panel, 200);
        }
    }
/**
 * @return {?}
 */
align() {
        if (this.appendTo)
            this.domHandler.absolutePosition(this.panel, (this.multiple ? this.multipleContainer : this.input));
        else
            this.domHandler.relativePosition(this.panel, (this.multiple ? this.multipleContainer : this.input));
    }
/**
 * @return {?}
 */
hide() {
        this.panelVisible = false;
    }
/**
 * @param {?} event
 * @return {?}
 */
handleDropdownClick(event) {
        this.onDropdownClick.emit({
            originalEvent: event,
            query: this.input.value
        });
    }
/**
 * @param {?} item
 * @return {?}
 */
removeItem(item: any) {
        let /** @type {?} */ itemIndex = this.domHandler.index(item);
        let /** @type {?} */ removedValue = this.value.splice(itemIndex, 1)[0];
        this.onUnselect.emit(removedValue);
        this.onModelChange(this.value);
    }
/**
 * @param {?} event
 * @return {?}
 */
onKeydown(event) {
        if (this.panelVisible) {
            let /** @type {?} */ highlightItemIndex = this.findOptionIndex(this.highlightOption);

            switch (event.which) {
                //down
                case 40:
                    if (highlightItemIndex != -1) {
                        var /** @type {?} */ nextItemIndex = highlightItemIndex + 1;
                        if (nextItemIndex != (this.suggestions.length)) {
                            this.highlightOption = this.suggestions[nextItemIndex];
                            this.highlightOptionChanged = true;
                        }
                    }
                    else {
                        this.highlightOption = this.suggestions[0];
                    }

                    event.preventDefault();
                    break;

                //up
                case 38:
                    if (highlightItemIndex > 0) {
                        let /** @type {?} */ prevItemIndex = highlightItemIndex - 1;
                        this.highlightOption = this.suggestions[prevItemIndex];
                        this.highlightOptionChanged = true;
                    }

                    event.preventDefault();
                    break;

                //enter
                case 13:
                    if (this.highlightOption) {
                        this.selectItem(this.highlightOption);
                        this.hide();
                    }
                    event.preventDefault();
                    break;

                //escape
                case 27:
                    this.hide();
                    event.preventDefault();
                    break;


                //tab
                case 9:
                    if (this.highlightOption) {
                        this.selectItem(this.highlightOption);
                    }
                    this.hide();
                    break;
            }
        } else {
            if (event.which === 40 && this.suggestions) {
                this.search(event, event.target.value);
            }
        }

        if (this.multiple) {
            switch (event.which) {
                //backspace
                case 8:
                    if (this.value && this.value.length && !this.input.value) {
                        let /** @type {?} */ removedValue = this.value.pop();
                        this.onUnselect.emit(removedValue);
                        this.onModelChange(this.value);
                    }
                    break;
            }
        }
    }
/**
 * @param {?} event
 * @return {?}
 */
onInputFocus(event) {
        this.focus = true;
        this.onFocus.emit(event);
    }
/**
 * @return {?}
 */
onBlur() {
        this.focus = false;
        this.onModelTouched();
    }
/**
 * @return {?}
 */
onDropdownFocus() {
        this.dropdownFocus = true;
        this.inputEL.nativeElement.focus();
    }
/**
 * @return {?}
 */
onDropdownBlur() {
        this.dropdownFocus = false;
    }
/**
 * @param {?} val
 * @return {?}
 */
isSelected(val: any): boolean {
        let /** @type {?} */ selected: boolean = false;
        if (this.value && this.value.length) {
            for (let /** @type {?} */ i = 0; i < this.value.length; i++) {
                if (this.objectUtils.equals(this.value[i], val)) {
                    selected = true;
                    break;
                }
            }
        }
        return selected;
    }
/**
 * @param {?} option
 * @return {?}
 */
findOptionIndex(option): number {
        let /** @type {?} */ index: number = -1;
        if (this.suggestions) {
            for (let /** @type {?} */ i = 0; i < this.suggestions.length; i++) {
                if (this.objectUtils.equals(option, this.suggestions[i])) {
                    index = i;
                    break;
                }
            }
        }

        return index;
    }
/**
 * @return {?}
 */
updateFilledState() {
        this.filled = this.input && this.input.value != '';
    }
/**
 * @return {?}
 */
ngOnDestroy() {
        if (this.documentClickListener) {
            this.documentClickListener();
        }

        if (this.appendTo) {
            this.el.nativeElement.appendChild(this.panel);
        }
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'p-autoComplete',
    template: `
        <span [ngClass]="{'ui-autocomplete ui-widget':true,'ui-autocomplete-dd':dropdown,'ui-autocomplete-multiple':multiple}" [ngStyle]="style" [class]="styleClass">
            <input *ngIf="!multiple" #in pInputText type="text" [ngStyle]="inputStyle" [class]="inputStyleClass" autocomplete="off"
            [value]="value ? (field ? objectUtils.resolveFieldData(value,field)||value : value) : null" (input)="onInput($event)" (keydown)="onKeydown($event)" (focus)="onInputFocus($event)" (blur)="onBlur()"
            [attr.placeholder]="placeholder" [attr.size]="size" [attr.maxlength]="maxlength" [attr.tabindex]="tabindex" [readonly]="readonly" [disabled]="disabled"
            [ngClass]="{'ant-input':true,'ui-autocomplete-dd-input':dropdown}"
            >
            <ul *ngIf="multiple" class="ui-autocomplete-multiple-container ui-widget ui-inputtext ui-state-default ui-corner-all" [ngClass]="{'ui-state-disabled':disabled,'ui-state-focus':focus}" (click)="multiIn.focus()">
                <li #token *ngFor="let val of value" class="ui-autocomplete-token ui-state-highlight ui-corner-all">
                    <span class="ui-autocomplete-token-icon fa fa-fw fa-close" (click)="removeItem(token)"></span>
                    <span *ngIf="!selectedItemTemplate" class="ui-autocomplete-token-label">{{field ? val[field] : val}}</span>
                    <ng-template *ngIf="selectedItemTemplate" [pTemplateWrapper]="selectedItemTemplate" [item]="val"></ng-template>
                </li>
                <li class="ui-autocomplete-input-token">
                    <input #multiIn type="text" [disabled]="disabled" pInputText [attr.placeholder]="placeholder" [attr.tabindex]="tabindex" (input)="onInput($event)" (keydown)="onKeydown($event)" (focus)="onInputFocus($event)" (blur)="onBlur()" autocomplete="off">
                </li>
            </ul
            >
            <button type="button" pButton icon="fa-fw fa-caret-down" class="ui-autocomplete-dropdown" [disabled]="disabled"
                (click)="handleDropdownClick($event)" *ngIf="dropdown" (focus)="onDropdownFocus($event)" (blur)="onDropdownBlur($event)"></button>
            <div class="ui-autocomplete-panel ui-widget-content ui-corner-all ui-shadow" [style.display]="panelVisible ? 'block' : 'none'" [style.width]="appendTo ? 'auto' : '100%'" [style.max-height]="scrollHeight">
                
                
                <ul *ngIf="panelVisible && hasChildren!=='hasChildren'" class="ui-autocomplete-items ui-autocomplete-list ui-widget-content ui-widget ui-corner-all ui-helper-reset">
                    <li *ngFor="let option of suggestions" [ngClass]="{'ui-autocomplete-list-item ui-corner-all':true,'ui-state-highlight':(highlightOption==option)}"
                        (mouseenter)="highlightOption=option" (mouseleave)="highlightOption=null" (click)="selectItem(option)">
                        <span *ngIf="!itemTemplate">{{field ? option[field] : option}}</span>
                        <ng-template *ngIf="itemTemplate" [pTemplateWrapper]="itemTemplate" [item]="option"></ng-template>
                    </li>
                </ul>
                <ul *ngIf="panelVisible && hasChildren==='hasChildren'" class="ui-autocomplete-items ui-autocomplete-list ui-widget-content ui-widget ui-corner-all ui-helper-reset">
                    <li *ngFor="let option of suggestions" [ngClass]="{'ui-autocomplete-list-item ui-corner-all':true}">
                       <div *ngIf="!itemTemplate" (click)="groupLabelClick($event)" class="ui-select-group-label">{{field ? option[field] : option.name}}</div>
                        <div *ngFor="let c of option.children"
                             class="ui-select-choices-row"
                              [ngClass]="{'ui-state-highlight':(highlightOption==c)}"
                             (click)="selectItem(c,$event)">
                          <a href="javascript:void(0)"  (mouseenter)="highlightOption=c" (mouseleave)="highlightOption=null" class="ui-select-choices-row-inner">
                            <span>{{field ? c[field] : c.name}}</span>
                          </a>
                        </div>
                        <ng-template *ngIf="itemTemplate" [pTemplateWrapper]="itemTemplate" [item]="option"></ng-template>
                    </li>
                </ul>
                
                
            </div>
        </span>
    `,
    //modified by giscafer
    styles: ['.ui-select-group-label{ font-weight: bold; } .ui-select-choices-row{margin:3px 0 3px 1em}'],
    host: {
        '[class.ui-inputwrapper-filled]': 'filled',
        '[class.ui-inputwrapper-focus]': 'focus'
    },
    providers: [DomHandler, ObjectUtils, AUTOCOMPLETE_VALUE_ACCESSOR]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: DomHandler, },
{type: IterableDiffers, },
{type: Renderer, },
{type: ObjectUtils, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'hasChildren': [{ type: Input },],
'minLength': [{ type: Input },],
'delay': [{ type: Input },],
'style': [{ type: Input },],
'styleClass': [{ type: Input },],
'inputStyle': [{ type: Input },],
'inputStyleClass': [{ type: Input },],
'placeholder': [{ type: Input },],
'readonly': [{ type: Input },],
'disabled': [{ type: Input },],
'maxlength': [{ type: Input },],
'size': [{ type: Input },],
'suggestions': [{ type: Input },],
'appendTo': [{ type: Input },],
'completeMethod': [{ type: Output },],
'onSelect': [{ type: Output },],
'onUnselect': [{ type: Output },],
'onFocus': [{ type: Output },],
'onDropdownClick': [{ type: Output },],
'field': [{ type: Input },],
'scrollHeight': [{ type: Input },],
'dropdown': [{ type: Input },],
'multiple': [{ type: Input },],
'tabindex': [{ type: Input },],
'templates': [{ type: ContentChildren, args: [PrimeTemplate, ] },],
'inputEL': [{ type: ViewChild, args: ['in', ] },],
};
}

function AutoComplete_tsickle_Closure_declarations() {
/** @type {?} */
AutoComplete.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AutoComplete.ctorParameters;
/** @type {?} */
AutoComplete.propDecorators;
/** @type {?} */
AutoComplete.prototype.hasChildren;
/** @type {?} */
AutoComplete.prototype.minLength;
/** @type {?} */
AutoComplete.prototype.delay;
/** @type {?} */
AutoComplete.prototype.style;
/** @type {?} */
AutoComplete.prototype.styleClass;
/** @type {?} */
AutoComplete.prototype.inputStyle;
/** @type {?} */
AutoComplete.prototype.inputStyleClass;
/** @type {?} */
AutoComplete.prototype.placeholder;
/** @type {?} */
AutoComplete.prototype.readonly;
/** @type {?} */
AutoComplete.prototype.disabled;
/** @type {?} */
AutoComplete.prototype.maxlength;
/** @type {?} */
AutoComplete.prototype.size;
/** @type {?} */
AutoComplete.prototype.suggestions;
/** @type {?} */
AutoComplete.prototype.appendTo;
/** @type {?} */
AutoComplete.prototype.completeMethod;
/** @type {?} */
AutoComplete.prototype.onSelect;
/** @type {?} */
AutoComplete.prototype.onUnselect;
/** @type {?} */
AutoComplete.prototype.onFocus;
/** @type {?} */
AutoComplete.prototype.onDropdownClick;
/** @type {?} */
AutoComplete.prototype.field;
/** @type {?} */
AutoComplete.prototype.scrollHeight;
/** @type {?} */
AutoComplete.prototype.dropdown;
/** @type {?} */
AutoComplete.prototype.multiple;
/** @type {?} */
AutoComplete.prototype.tabindex;
/** @type {?} */
AutoComplete.prototype.templates;
/** @type {?} */
AutoComplete.prototype.itemTemplate;
/** @type {?} */
AutoComplete.prototype.selectedItemTemplate;
/** @type {?} */
AutoComplete.prototype.value;
/** @type {?} */
AutoComplete.prototype.onModelChange;
/** @type {?} */
AutoComplete.prototype.onModelTouched;
/** @type {?} */
AutoComplete.prototype.timeout;
/** @type {?} */
AutoComplete.prototype.timeout2;
/** @type {?} */
AutoComplete.prototype.differ;
/** @type {?} */
AutoComplete.prototype.panel;
/** @type {?} */
AutoComplete.prototype.input;
/** @type {?} */
AutoComplete.prototype.multipleContainer;
/** @type {?} */
AutoComplete.prototype.panelVisible;
/** @type {?} */
AutoComplete.prototype.documentClickListener;
/** @type {?} */
AutoComplete.prototype.suggestionsUpdated;
/** @type {?} */
AutoComplete.prototype.highlightOption;
/** @type {?} */
AutoComplete.prototype.highlightOptionChanged;
/** @type {?} */
AutoComplete.prototype.focus;
/** @type {?} */
AutoComplete.prototype.dropdownFocus;
/** @type {?} */
AutoComplete.prototype.filled;
/** @type {?} */
AutoComplete.prototype.inputEL;
/** @type {?} */
AutoComplete.prototype.el;
/** @type {?} */
AutoComplete.prototype.domHandler;
/** @type {?} */
AutoComplete.prototype.renderer;
/** @type {?} */
AutoComplete.prototype.objectUtils;
}

export class AutoCompleteModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule, InputTextModule, ButtonModule, PrimeNGSharedModule],
    exports: [AutoComplete, PrimeNGSharedModule],
    declarations: [AutoComplete]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function AutoCompleteModule_tsickle_Closure_declarations() {
/** @type {?} */
AutoCompleteModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AutoCompleteModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
